import { Row, Col, message, Button, Modal, Form, Input, Badge, Card, FloatButton } from 'antd';
import { DollarOutlined, CalendarOutlined, FileTextOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { Navigate, Link, useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import ObraSelect from '../components/ObraSelect';
import axios from "./../services/http";


function HomeLayout() {

    const location = useLocation();
    const navigate = useNavigate();
    const { from } = location.state || { from: { pathname: "/home" } };
    const [obras, setObras] = useState([]);
    const [selectedObra, setSelectedObra] = useState(null);
    const [isAdmin, setIsAdmin] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [newObraName, setNewObraName] = useState('');
    const [paymentCtrlCount, setPaymentCtrlCount] = useState(0);

    useEffect(() => {
        fetchObras();
        fetchPaymentCtrlCount();
        if (from && from.id) {
            setSelectedObra(from);
        }
        const decoded = jwtDecode(localStorage.getItem("token"));
        if (decoded && decoded.privilegios) {
            setIsAdmin(decoded.privilegios === "Admin" ? true : false);
        }
    }, []);

    const fetchObras = async () => {
        try {
            const response = await axios.HTTP_GET("/api/obras");
            if (response) setObras(response);
        } catch (error) {
            console.error('Error al obtener las obras:', error);
            message.error(error);
        }
    };

    const fetchPaymentCtrlCount = async () => {
        try {
            const decoded = jwtDecode(localStorage.getItem("token"));
            const response = await axios.HTTP_POST("/api/v1/payments/count", { estatus: 'POR AUTORIZAR', rol: decoded.privilegios, usuario: decoded.id });
            if (response && response.data) setPaymentCtrlCount(response.data);
        } catch (e) {
            console.error('Error al obtener el conteo:', e);
            message.error(e);
        }
    }

    const handleObraChange = (params) => setSelectedObra(params);

    const handleCreateObra = async () => {
        if (!newObraName.trim()) {
            message.error('Escribe un nombre válido de Obra');
            return;
        }
        try {
            const response = await axios.HTTP_POST("/api/construction/save", { nombre_obra: newObraName });
            if (response) {
                message.success('Obra creada exitosamente');
                setObras([...obras, response.data]);
                setNewObraName('');
                setOpenDialog(false);
                handleObraChange(response.data);
            }
        } catch (error) {
            console.error('Error al crear la obra:', error);
            message.error('Hubo un error al crear la obra');
        }
    };


    return (
        <>
            <Row gutter={[20, 20]}>
                <Col xs={{ flex: '100%' }} md={{ flex: '40%' }} style={{ height: "200px" }}>
                    <div className='container bg-white border-1'>
                        <ObraSelect
                            selectedObra={selectedObra}
                            handleObraChange={handleObraChange}
                            obras={obras}
                        />

                        <div style={{ textAlign: 'center', margin: '16px 0' }}>
                            <Button type="primary" onClick={() => setOpenDialog(true)}>
                                Nueva Obra
                            </Button>
                        </div>
                    </div>
                </Col>
                <Col xs={{ flex: '100%' }} md={{ flex: '60%' }}>
                    {selectedObra ?
                        <div>
                            <Row gutter={18} style={{ marginBottom: 10 }} justify="start">
                                <Col xs={24} md={12}>
                                    <Link to={{ pathname: '/payment-control' }} state={{ from: selectedObra }} >
                                        <Card hoverable title="Crear Control de Pago">
                                            <p>Gestionar los pagos de la obra seleccionada..</p>
                                        </Card>
                                    </Link>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Link to={{ pathname: '/add-amount' }} state={{ from: selectedObra }} >
                                        <Card hoverable title="Ingresar pago">
                                            <p>Añadir nuevos montos a la obra seleccionada.</p>
                                        </Card>
                                    </Link>
                                </Col>
                            </Row>
                            <Row gutter={18} style={{ marginBottom: 10 }} justify="start">
                                <Col xs={24} md={12}>
                                    <Link to={{ pathname: '/payment-control-toAuthorize' }} state={{ from: selectedObra }} >
                                        <Badge count={paymentCtrlCount} overflowCount={10}>
                                            <Card hoverable title="Controles de pago (Por Autorizar)">
                                                <p>Ver y gestionar los controles de pago de la obra seleccionada que aún no han sido autorizados.
                                                </p>
                                            </Card>
                                        </Badge>
                                    </Link>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Link to={{ pathname: '/payment-control-list' }} state={{ from: selectedObra }} >
                                        <Card hoverable title="Controles de pago">
                                            <p>Ver y gestionar los controles de pago de la obra seleccionada.</p>
                                        </Card>
                                    </Link>
                                </Col>
                            </Row>
                            <Row gutter={18} style={{ marginBottom: 10 }} justify="start">
                                <Col xs={24} md={12}>
                                    <Link to={{ pathname: '/fiscal' }} state={{ from: selectedObra }} >
                                        <Card hoverable title="Fiscal">
                                            <p>Ver controles de pago fiscales.</p>
                                        </Card>
                                    </Link>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Link to={{ pathname: '/no-fiscal' }} state={{ from: selectedObra }} >
                                        <Card hoverable title="No Fiscal">
                                            <p>Ver controles de pago No fiscales.</p>
                                        </Card>
                                    </Link>
                                </Col>
                            </Row>
                            <Row gutter={18} justify="start">
                                <Col xs={24} md={12}>
                                    <Link to={{ pathname: '/builders' }} state={{ from: selectedObra }} >
                                        <Card hoverable title="Control de Contratistas">
                                            <p>Ver controles de contratistas de la obra.</p>
                                        </Card>
                                    </Link>
                                </Col>
                                <Col xs={24} md={12} style={{ marginBottom: 10 }}>
                                    <Link to={{ pathname: '/relationships' }} state={{ from: selectedObra }} >
                                        <Card hoverable title="Relaciones">
                                            <p>Ver relaciones de la obra.</p>
                                        </Card>
                                    </Link>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Link to={{ pathname: '/budget-control' }} state={{ from: selectedObra }} >
                                        <Card hoverable title="Control de Presupuesto">
                                            <p>Ver relaciones por partida.</p>
                                        </Card>
                                    </Link>
                                </Col>
                            </Row>
                        </div>
                        : <></>}
                </Col>

            </Row>
            <Modal
                title="Crear Nueva Obra"
                open={openDialog}
                onCancel={() => setOpenDialog(false)}
                footer={[
                    <Button key="cancel" onClick={() => setOpenDialog(false)}>
                        Cancelar
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateObra}>
                        Guardar
                    </Button>,
                ]}
            >
                <Form layout="vertical">
                    <Form.Item label="Nombre de la Obra">
                        <Input
                            value={newObraName}
                            onChange={(e) => setNewObraName(e.target.value)}
                        />
                    </Form.Item>
                </Form>
            </Modal>
            <FloatButton.Group shape="square" style={{ right: 24, bottom: 24 }}>
                <FloatButton
                    tooltip={<div>Estado de cuenta</div>}
                    icon={<DollarOutlined />}
                    type="primary"
                    onClick={() => navigate('/statement')}
                />
                <FloatButton
                    tooltip={<div>Quincenas</div>}
                    icon={<CalendarOutlined />}
                    onClick={() => navigate('/quincenas')}
                />
                <FloatButton
                    tooltip={<div>Folios</div>}
                    icon={<FileTextOutlined />}
                    onClick={() => navigate('/folios')}
                />
            </FloatButton.Group>
        </>
    )
}

export default HomeLayout;